/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  ACCOUNT_LOCATED,
  CLAIMS_QORE_ACCOUNT,
  CLEAR_COMPANY_CREATE_FLAG,
  CREATE_COMPANY,
  CREATE_USER,
  CREATE_USER_ROLE,
  CREATE_USER_TOKEN,
  REGISTRATION_COMPLETE,
  UPDATE_DEALER,
  UPDATE_PROFILE,
  VERIFICATION_RESULTS,
  UPDATE_USER
} from 'src/actions/accountActions';

const initialState = {
  appSettings: null,
  user: null,
  companyCreated: false,
  companyUser: null,
  userToken: null,
  claimQoreUser: {},
  dealerInfo: {},
  accountMatches: [],
  dealerVerificationResult: { exists: false }
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_LOCATED: {
      const { accountMatches } = action.payload;

      return produce(state, draft => {
        draft.accountMatches = accountMatches;
      });
    }

    case CLAIMS_QORE_ACCOUNT: {
      const { claimQoreUser } = action.payload;

      return produce(state, draft => {
        draft.claimQoreUser = claimQoreUser;
      });
    }
    case VERIFICATION_RESULTS: {
      const { dealerVerificationResult } = action.payload;

      return produce(state, draft => {
        draft.dealerVerificationResult.exists = dealerVerificationResult.exists;
      });
    }

    case REGISTRATION_COMPLETE: {
      const { user } = action.payload;

      return produce(state, draft => {
        draft.user = user;
      });
    }

    case UPDATE_PROFILE: {
      const { user } = action.payload;

      return produce(state, draft => {
        draft.user = user;
      });
    }

    case UPDATE_USER: {
      const { dealerUser } = action.payload;

      return produce(state, draft => {
        draft.dealerUser = { ...draft.dealerUser, ...dealerUser };
      });
    }

    case UPDATE_DEALER: {
      const dealer = action.payload;

      return produce(state, draft => {
        draft.dealerInfo = dealer;
      });
    }

    case CREATE_COMPANY: {
      return produce(state, draft => {
        draft.companyCreated = true;
      });
    }

    case CREATE_USER: {
      return produce(() => { });
    }

    case CREATE_USER_ROLE: {
      return produce(() => { });
    }

    case CREATE_USER_TOKEN: {
      return produce(() => { });
    }

    case CLEAR_COMPANY_CREATE_FLAG: {
      return produce(state, draft => {
        draft.companyCreated = false;
      });
    }
    default: {
      return state;
    }
  }
};

export default accountReducer;
